import { IconButton, InputAdornment, TextField, useMediaQuery} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Search } from '@mui/icons-material';
import { useState } from 'react';


const MenuSearchInput = (): JSX.Element => {

    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [searchInput, setSearchInput] = useState<string>('');

    const changeSearchInput = (event: any) => {
        setSearchInput(event.target.value);
    };

    const updateSearchInput = () => {
        window.location.href = '/Search?q=' + searchInput;
     }

     const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            updateSearchInput();
        }
      };

    return(
        <>
          <TextField
            label={"Search OCPF"}
            id="search-input"
            size="small"
            sx={{ m: 0, p:0, maxWidth: isSM?110:160, fontSize: 'medium' }}
            onKeyDown={handleKeyDown}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={updateSearchInput}
                      edge="end"
                      aria-label="Submit search"
                    >
                    <Search />
                    </IconButton>
                  </InputAdornment>
                ) ,
              },
            }}
            onChange={changeSearchInput}
          /> 
        </>
    )
}

export default MenuSearchInput;